/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Prorated_ExplanationInputs */

const en_admin_membership_confirmations_prorated_explanation = /** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An invoice for the time between the start date and the first monthly invoice`)
};

const nl_admin_membership_confirmations_prorated_explanation = /** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een factuur voor de tijd tussen de startdatum en de eerste maandelijkse factuur`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */
const de_admin_membership_confirmations_prorated_explanation = en_admin_membership_confirmations_prorated_explanation;

/** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */
const es_admin_membership_confirmations_prorated_explanation = en_admin_membership_confirmations_prorated_explanation;

/** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */
const fr_admin_membership_confirmations_prorated_explanation = en_admin_membership_confirmations_prorated_explanation;

/** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */
const it_admin_membership_confirmations_prorated_explanation = en_admin_membership_confirmations_prorated_explanation;

/** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_prorated_explanation = en_admin_membership_confirmations_prorated_explanation;

/** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */
const pl_admin_membership_confirmations_prorated_explanation = en_admin_membership_confirmations_prorated_explanation;

/** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */
const hu_admin_membership_confirmations_prorated_explanation = en_admin_membership_confirmations_prorated_explanation;

/** @type {(inputs: Admin_Membership_Confirmations_Prorated_ExplanationInputs) => LocalizedString} */
const ro_admin_membership_confirmations_prorated_explanation = en_admin_membership_confirmations_prorated_explanation;

/**
* | output |
* | --- |
* | "An invoice for the time between the start date and the first monthly invoice" |
*
* @param {Admin_Membership_Confirmations_Prorated_ExplanationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_prorated_explanation = /** @type {((inputs?: Admin_Membership_Confirmations_Prorated_ExplanationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Prorated_ExplanationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_prorated_explanation(inputs)
	if (locale === "de") return de_admin_membership_confirmations_prorated_explanation(inputs)
	if (locale === "es") return es_admin_membership_confirmations_prorated_explanation(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_prorated_explanation(inputs)
	if (locale === "nl") return nl_admin_membership_confirmations_prorated_explanation(inputs)
	if (locale === "it") return it_admin_membership_confirmations_prorated_explanation(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_prorated_explanation(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_prorated_explanation(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_prorated_explanation(inputs)
	return ro_admin_membership_confirmations_prorated_explanation(inputs)
});
export { admin_membership_confirmations_prorated_explanation as "admin.membership_confirmations.prorated_explanation" }